/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Callout_1_LabelInputs */

const en_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateurs`)
};

const es_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateurs`)
};

const de_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateure`)
};

const zh_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`业余球员`)
};

const ar_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهواة`)
};

const fr_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateurs`)
};

const vi_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nghiệp dư`)
};

const sw_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji wa ridhaa`)
};

const th_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักกอล์ฟสมัครเล่น`)
};

const bs_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateri`)
};

const ja_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アマチュア`)
};

const ko_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아마추어`)
};

const pt_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amadores`)
};

const it_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatori`)
};

const sv_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatörer`)
};

const nl_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateurs`)
};

const da_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatører`)
};

const nb_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatører`)
};

const fi_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatöörit`)
};

const pl_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatorzy`)
};

const ru_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любители`)
};

const tr_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatörler`)
};

const hi_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शौकिया खिलाड़ी`)
};

const id_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatir`)
};

const ms_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatur`)
};

const cs_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatéři`)
};

const el_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ερασιτέχνες`)
};

const he_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חובבים`)
};

const af_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateurs`)
};

const hu_injury_content_callout_1_label = /** @type {(inputs: Injury_Content_Callout_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatőrök`)
};

/**
* | output |
* | --- |
* | "Amateurs" |
*
* @param {Injury_Content_Callout_1_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_callout_1_label = /** @type {((inputs?: Injury_Content_Callout_1_LabelInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Callout_1_LabelInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_callout_1_label(inputs)
	if (locale === "de") return de_injury_content_callout_1_label(inputs)
	if (locale === "zh") return zh_injury_content_callout_1_label(inputs)
	if (locale === "ar") return ar_injury_content_callout_1_label(inputs)
	if (locale === "fr") return fr_injury_content_callout_1_label(inputs)
	if (locale === "vi") return vi_injury_content_callout_1_label(inputs)
	if (locale === "sw") return sw_injury_content_callout_1_label(inputs)
	if (locale === "th") return th_injury_content_callout_1_label(inputs)
	if (locale === "bs") return bs_injury_content_callout_1_label(inputs)
	if (locale === "ja") return ja_injury_content_callout_1_label(inputs)
	if (locale === "ko") return ko_injury_content_callout_1_label(inputs)
	if (locale === "pt") return pt_injury_content_callout_1_label(inputs)
	if (locale === "it") return it_injury_content_callout_1_label(inputs)
	if (locale === "sv") return sv_injury_content_callout_1_label(inputs)
	if (locale === "nl") return nl_injury_content_callout_1_label(inputs)
	if (locale === "da") return da_injury_content_callout_1_label(inputs)
	if (locale === "nb") return nb_injury_content_callout_1_label(inputs)
	if (locale === "fi") return fi_injury_content_callout_1_label(inputs)
	if (locale === "pl") return pl_injury_content_callout_1_label(inputs)
	if (locale === "ru") return ru_injury_content_callout_1_label(inputs)
	if (locale === "tr") return tr_injury_content_callout_1_label(inputs)
	if (locale === "hi") return hi_injury_content_callout_1_label(inputs)
	if (locale === "id") return id_injury_content_callout_1_label(inputs)
	if (locale === "ms") return ms_injury_content_callout_1_label(inputs)
	if (locale === "cs") return cs_injury_content_callout_1_label(inputs)
	if (locale === "el") return el_injury_content_callout_1_label(inputs)
	if (locale === "he") return he_injury_content_callout_1_label(inputs)
	if (locale === "af") return af_injury_content_callout_1_label(inputs)
	if (locale === "hu") return hu_injury_content_callout_1_label(inputs)
	return en_injury_content_callout_1_label(inputs)
});